module.exports = __webpack_public_path__ + "img/e_2_4_g.b76f0068.png";